import { Checkbox, CityState, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Location, Panel, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTenderList extends Layout {
    checkboxEdiOrderNoDisplay: Checkbox;
    citystateEdiStopDestCityId: CityState;
    citystateEdiStopOriginCityId: CityState;
    dataheaderTendersList: DataHeader;
    horizontalspacer3: HorizontalSpacer;
    labelReply: Label;
    labelTenders: Label;
    panelConsigneeLocation: Panel;
    panelSearch: Panel;
    panelShipperLocation: Panel;
    searchpanelTenders: SearchPanel;
    sourceEdiOrdersList: DataSource;
    switchIntercompany: Switch;
    switchReplyTransmitted: Switch;
    tableTenders: Table;
    textboxDestLocation: Location;
    textboxEdiOrderCreateDate: Textbox;
    textboxEdiOrderCustomerId: Textbox;
    textboxEdiOrderDirection: Textbox;
    textboxEdiOrderId: Textbox;
    textboxEdiOrderOrderId: Textbox;
    textboxEdiOrderPartnerId: Textbox;
    textboxEdiOrderPurposeType: Textbox;
    textboxEdiOrderReplyAction: Textbox;
    textboxEdiOrderReplyBatchId: Textbox;
    textboxEdiOrderReplyDate: Textbox;
    textboxEdiOrderReplyReason: Textbox;
    textboxEdiOrderRevenueCodeId: Textbox;
    textboxEdiOrderShipmentId: Textbox;
    textboxEdiStopDestAddress2: Textbox;
    textboxEdiStopDestAddress: Textbox;
    textboxEdiStopDestLocationId: Textbox;
    textboxEdiStopDestLocationName: Textbox;
    textboxEdiStopDestSchedArriveEarly: Textbox;
    textboxEdiStopOriginAddress2: Textbox;
    textboxEdiStopOriginAddress: Textbox;
    textboxEdiStopOriginLocationId: Textbox;
    textboxEdiStopOriginLocationName: Textbox;
    textboxEdiStopOriginSchedArriveEarly: Textbox;
    textboxOriginLocation: Location;
    textboxReferenceNumbers: Textbox;
}
